import React from "react";
import TotalPrograms from "../components/pages/Dashboard/TotalPrograms";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const TotalUsersLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <TotalPrograms />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default TotalUsersLayout;